import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Link, IconButton, InputAdornment
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { postData } from "../../Webservice/Webservice";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useGoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";

function Signin() {
  const navigate = useNavigate();
  const [isPhoneLogin, setIsPhoneLogin] = useState(false);
  const [isResetPassword, setIsResetPassword] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    mobile: "",
    otp: "",
    type: "email",
  });

  const googleLogin = useGoogleLogin({
    scope: "openid profile email",
    onSuccess: async (tokenResponse) => {
      try {
        // 🔥 Step 1: Get user info from Google
        const userInfo = await fetch(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.access_token}`,
            },
          }
        ).then(res => res.json());

        console.log("Google User Info:", userInfo);


        const payload = {
          email: userInfo.email,
          token: tokenResponse.access_token, // google token
          type: "google",
          customerType: "business",
        };

        const response = await postData("customer/login", payload);

        if (response && !response.error) {
          sessionStorage.setItem("token", response.token);
          sessionStorage.setItem("commonToken", response.token);
          sessionStorage.setItem("userType", "common");

          if (response.customer) {
            sessionStorage.setItem("user", JSON.stringify(response.customer));
          }

          toast.success("Login Successful");
          navigate("/");
        }
      } catch (error) {
        console.error("Google login error:", error);
        toast.error("Google login failed. Please try again.");
      }
    },
    onError: () => {
      toast.error("Google Login Failed");
    },
  });


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.email || !formData.password) {
      toast.error("Please fill in all required fields");
      return;
    }

    const payload = {
      email: formData.email,
      password: formData.password,
      type: "email",
      customerType: "business"
    };

    try {
      const response = await postData("customer/login", payload);
      if (response && !response.error) {
        // Store tokens and user info
        if (response.token) {
          sessionStorage.setItem("token", response.token);
          sessionStorage.setItem("commonToken", response.token);
          sessionStorage.setItem("userType", "common");
          if (response.customer) {
            sessionStorage.setItem("user", JSON.stringify(response.customer));
          }
        }
        navigate("/");
      }
    } catch (error) {
      console.error("Signin error:", error);
    }
  };

  const handlePhoneSubmit = async () => {
    if (!formData.mobile) {
      toast.error("Please enter mobile number");
      return;
    }

    const payload = {
      mobile: formData.mobile,
      type: "mobile",
      customerType: "customer"
    };

    try {
      const response = await postData("customer/register", payload);
      if (response && !response.error) {
        toast.success("OTP sent successfully");
        setIsOtpSent(true);
      }
    } catch (error) {
      console.error("Phone login error:", error);
    }
  };

  const handleVerifyOtp = async () => {
    if (!formData.otp) {
      toast.error("Please enter OTP");
      return;
    }

    const payload = {
      mobile: formData.mobile,
      code: formData.otp
    };

    try {
      const response = await postData("customer/verify-mobile-otp", payload);
      if (response && !response.error) {
        // Store tokens and user info
        if (response.token) {
          sessionStorage.setItem("token", response.token);
          sessionStorage.setItem("commonToken", response.token);
          sessionStorage.setItem("userType", "common");
          if (response.customer) {
            sessionStorage.setItem("user", JSON.stringify(response.customer));
          }
        }
        toast.success("Login successful");
        navigate("/");
      }
    } catch (error) {
      console.error("OTP verification error:", error);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
      }}
    >
      {/* Left Section - Signin Form */}
      <Box
        sx={{
          flex: 1,
          backgroundColor: "white",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          maxWidth: 550,
        }}
      >
        <Box sx={{ maxWidth: 350, width: "100%", mx: "auto", textAlign: "center" }}>
          <Box
            component="img"
            src="/img/tvfmlogo2.png"
            alt="TVFM Logo"
            sx={{
              height: 55,
              width: "auto",
              mb: 2,
            }}
          />

          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", mb: 1, color: "#000" }}
          >
            {isResetPassword ? "Reset Password" : "Sign In"}
          </Typography>

          <Box component="form" noValidate onSubmit={handleSubmit}>

            {!isPhoneLogin ? (
              !isResetPassword ? (
                <>
                  {/* Email */}
                  <TextField
                    fullWidth
                    label="Email address"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    variant="outlined"
                    margin="normal"
                    required
                  />

                  {/* Password */}
                  <TextField
                    fullWidth
                    label="Password"
                    name="password"
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    onChange={handleChange}
                    variant="outlined"
                    margin="normal"
                    required
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <Typography variant="body2" align="right" sx={{ mt: 1, mb: 1, color: "#666" }}>
                    <Link
                      component="button"
                      type="button"
                      variant="body2"
                      onClick={() => setIsResetPassword(true)}
                      underline="hover"
                    >
                      Reset Password
                    </Link>
                  </Typography>

                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{
                      mt: 3,
                      mb: 2,
                      py: 1.2,
                      borderRadius: "8px",
                      textTransform: "none",
                      fontSize: "1rem",
                      backgroundColor: "#000",
                      "&:hover": { backgroundColor: "#333" },
                    }}
                  >
                    Sign In
                  </Button>
                </>
              ) : (
                <>
                  <Typography variant="body2" sx={{ mb: 2, color: "#666" }}>
                    Enter your email address and we'll send you a link to reset your password.
                  </Typography>

                  {/* Email */}
                  <TextField
                    fullWidth
                    label="Email address"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    variant="outlined"
                    margin="normal"
                    required
                  />

                  <Button
                    fullWidth
                    variant="contained"
                    onClick={async () => {
                      if (!formData.email) {
                        toast.error("Please enter email address");
                        return;
                      }

                      const payload = {
                        email: formData.email,
                        customerType: "business",
                      };

                      try {
                        const response = await postData("customer/forgot-password", payload);
                        if (response && !response.error) {
                          toast.success("Reset link sent to " + formData.email);
                          setIsResetPassword(false);
                        }
                      } catch (error) {
                        console.error("Forgot password error:", error);
                        toast.error("Failed to send reset link");
                      }
                    }}
                    sx={{
                      mt: 3,
                      mb: 2,
                      py: 1.2,
                      borderRadius: "8px",
                      textTransform: "none",
                      fontSize: "1rem",
                      backgroundColor: "#000",
                      "&:hover": { backgroundColor: "#333" },
                    }}
                  >
                    Send Link
                  </Button>

                  <Typography variant="body2" align="center" sx={{ mt: 2 }}>
                    <Link
                      component="button"
                      type="button"
                      variant="body2"
                      onClick={() => setIsResetPassword(false)}
                      underline="hover"
                    >
                      Back to Sign In
                    </Link>
                  </Typography>
                </>
              )
            ) : (
              <>
                {!isOtpSent ? (
                  <>
                    {/* Mobile Number */}
                    <TextField
                      fullWidth
                      label="Mobile Number"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                      variant="outlined"
                      margin="normal"
                      required
                    />

                    <Button
                      fullWidth
                      variant="contained"
                      onClick={handlePhoneSubmit}
                      sx={{
                        mt: 3,
                        mb: 2,
                        py: 1.2,
                        borderRadius: "8px",
                        textTransform: "none",
                        fontSize: "1rem",
                        backgroundColor: "#000",
                        "&:hover": { backgroundColor: "#333" },
                      }}
                    >
                      Send OTP
                    </Button>
                  </>
                ) : (
                  <>
                    {/* OTP Input */}
                    <TextField
                      fullWidth
                      label="Enter 6-digit OTP"
                      name="otp"
                      value={formData.otp}
                      onChange={handleChange}
                      variant="outlined"
                      margin="normal"
                      required
                      inputProps={{ maxLength: 6 }}
                    />

                    <Button
                      fullWidth
                      variant="contained"
                      onClick={handleVerifyOtp}
                      sx={{
                        mt: 3,
                        mb: 2,
                        py: 1.2,
                        borderRadius: "8px",
                        textTransform: "none",
                        fontSize: "1rem",
                        backgroundColor: "#000",
                        "&:hover": { backgroundColor: "#333" },
                      }}
                    >
                      Verify OTP
                    </Button>
                  </>
                )}
              </>
            )}

            {/* Divider with "or" text */}
            <Box sx={{ display: 'flex', alignItems: 'center', my: 2 }}>
              <Box sx={{ flex: 1, height: '1px', backgroundColor: '#e0e0e0' }} />
              <Typography variant="body2" sx={{ px: 2, color: '#666' }}>
                or
              </Typography>
              <Box sx={{ flex: 1, height: '1px', backgroundColor: '#e0e0e0' }} />
            </Box>

            {/* Phone/Email Toggle Button */}
            {/* <Button
              fullWidth
              variant="outlined"
              startIcon={isPhoneLogin ? null : <Phone />}
              onClick={() => {
                setIsPhoneLogin(!isPhoneLogin);
                setIsOtpSent(false); // Reset OTP state when switching
              }}
              sx={{
                mb: 2,
                py: 1.2,
                borderRadius: "8px",
                textTransform: "none",
                fontSize: "1rem",
                borderColor: '#000',
                color: '#000',
                "&:hover": {
                  borderColor: '#333',
                  backgroundColor: 'rgba(0,0,0,0.04)'
                },
              }}
            >
              {isPhoneLogin ? "Sign in with Email" : "Sign in with Phone"}
            </Button> */}

            {/* Google Sign In Button */}
            <Button
              fullWidth
              variant="outlined"
              onClick={() => googleLogin()}
              startIcon={
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.494 12.275c0-.868-.077-1.703-.223-2.503H12v4.735h6.446c-.278 1.498-1.122 2.766-2.392 3.615v3.007h3.873c2.265-2.083 3.567-5.152 3.567-8.854z"
                    fill="#4285F4"
                  />
                  <path
                    d="M12 24c3.24 0 5.957-1.074 7.942-2.915l-3.873-3.007c-1.074.72-2.446 1.144-4.069 1.144-3.13 0-5.78-2.112-6.727-4.949H1.323v3.109C3.3 21.173 7.377 24 12 24z"
                    fill="#34A853"
                  />
                  <path
                    d="M5.273 14.273c-.245-.72-.385-1.487-.385-2.273s.14-1.553.385-2.273V6.618H1.323C.48 8.238 0 10.06 0 12s.48 3.762 1.323 5.382l3.95-3.109z"
                    fill="#FBBC05"
                  />
                  <path
                    d="M12 4.773c1.762 0 3.344.605 4.587 1.791l3.44-3.44C17.952 1.077 15.235 0 12 0 7.377 0 3.3 2.827 1.323 6.618l3.95 3.109c.947-2.837 3.597-4.954 6.727-4.954z"
                    fill="#EA4335"
                  />
                </svg>
              }
              sx={{
                mb: 2,
                py: 1.5,
                borderRadius: "12px",
                textTransform: "none",
                fontSize: "1rem",
                fontWeight: 500,
                borderColor: '#e0e0e0',
                backgroundColor: '#ffffff',
                color: '#3c4043',
                fontFamily: "'Google Sans', Roboto, Arial, sans-serif",
                boxShadow: '0 1px 2px 0 rgba(60,64,67,0.30), 0 1px 3px 1px rgba(60,64,67,0.15)',
                transition: 'all 0.2s ease-in-out',
                "&:hover": {
                  borderColor: '#d2e3fc',
                  backgroundColor: '#f8faff',
                  boxShadow: '0 1px 3px 0 rgba(60,64,67,0.30), 0 4px 8px 3px rgba(60,64,67,0.15)',
                },
                "&:active": {
                  backgroundColor: '#eeeeee',
                  boxShadow: '0 1px 2px 0 rgba(60,64,67,0.30), 0 1px 3px 1px rgba(60,64,67,0.15)',
                }
              }}
            >
              Sign in with Google
            </Button>
          </Box>

          <Typography variant="body2" align="center" sx={{ mt: 2 }}>
            Create a free account{" "}
            <Link href='/signup' underline="hover">
              Sign up
            </Link>
          </Typography>
        </Box>
      </Box>

      {/* Right Section - Image */}
      <Box
        sx={{
          flex: 1,
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "white",
          position: "relative",
          overflow: "hidden",

        }}
      >
        <Box
          component="img"
          src="img/r1.jpg"
          alt="Signin Visual"
          sx={{
            width: "100%",
            height: "100vh",
            objectFit: "cover",
            objectPosition: "center",
          }}
        />
      </Box>
    </Box>
  );
}

export default Signin;